import React from 'react';
import component, {classnames} from './component';

export default component('HtmlContent', function({className, html, ...props}) {
  const markup = {__html: html || ''};
  return <div className={classnames(className, 'HtmlContent')}
              dangerouslySetInnerHTML={markup} {...props}/>;
});



// WEBPACK FOOTER //
// ./src/components/HtmlContent.js